import { createContext } from "react";
import { IAuthContext } from "./models/IAuthContext.ts";

export const AuthContext = createContext<IAuthContext>({
    confirmRegistration: async (token: string) => { token },
    resetPassword: async (verificationToken: string, password: string, confirmPassword: string) => { verificationToken; password; confirmPassword },
    login: async (reCaptchaToken: string, email: string, password: string, rememberMe: boolean, osInfo: string) => { email; password; reCaptchaToken; rememberMe; osInfo },
    loginPHP: async (reCaptchaToken: string, id: number, password: string, rememberMe: boolean, osInfo: string, fcmToken: string) => { id; password; reCaptchaToken; rememberMe; osInfo; fcmToken; },
    logout: async () => { },
    logoutFromAllDevices: async () => { },
    token: "",
    isRefreshTokenAvailable: false,
    user: null,
    setUser: () => { }
});